import BuilderSDK from '@builder.io/sdk';

import { BuilderConfig } from '../../../types/Builder';
import B2BCollapse, { B2BCollapseProps } from './b2b-collapse';

export const B2BCollapseTextBuilderConfig: BuilderSDK.Component = {
    name: 'B2B Collapse',
    image: 'https://cdn.builder.io/api/v1/image/assets%2F035a3d41874344d79b6c7499e2e7a5bc%2F3810bcb3ce57490b8f66ce0b394f54a2',
    screenshot: 'https://cdn.builder.io/api/v1/image/assets%2F035a3d41874344d79b6c7499e2e7a5bc%2F8bfa3504d5c84d9eaf5dfa7950c7e768',
    canHaveChildren: true,
    inputs: [
        {
            name: 'item',
            type: 'object',
            copyOnAdd: false,
            subFields: [
                { name: 'title', type: 'richText' },
                { name: 'content', type: 'uiBlocks', defaultValue: [] },
            ],
            defaultValue: {
                name: 'Collapse 1',
                content: [],
            },
        },
    ],
};

const builderConfig: BuilderConfig<B2BCollapseProps> = {
    component: B2BCollapse,
    config: B2BCollapseTextBuilderConfig,
};

export default builderConfig;
